module.exports = __webpack_public_path__ + "static/img/user_bg1.bc13662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/backgrounds/user_bg1.png
// module id = oDOZ
// module chunks = 31